export const ROSTER_CONST = {
  EMPTY: {
    EMPLOYEE_INFO: "Please add employee information",
    TRUCK_INFO: "Please add truck information",
  },
};

export enum GENERAL {
  ROSTER = "Roster",
}

export enum JobTypes {
  DAY_CONTRACT_JOB = "Day Contract Job",
  DAY_LABOUR_JOB = "Day Labour Job",
  NIGHT_CONTRACT_JOB = "Night Contract Job",
  NIGHT_LABOUR_JOB = "Night Labour Job",
}

export enum FleetTypes {
  ALLOCATED = "Allocated Fleet",
  UNALLOCATED = "Unallocated Fleet",
}

export type DaysheetJobFields =
  | "customerId"
  | "projectId"
  | "startTime"
  | "date"
  | "noe"
  | "employees"
  | "notes"
  | "type"
  | "status";

export type FleetJobFields =
  | "customerId"
  | "projectId"
  | "siteAddress"
  | "time"
  | "jobDescription"
  | "report"
  | "date"
  | "isAllocated"
  | "status";

export enum StatusTypes {
  SENT = "SENT",
  DRAFT = "DRAFT",
  EDITED = "EDITED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}

export const StatusList = [
  {
    value: StatusTypes.SENT,
    label: "Sent",
  },
  {
    value: StatusTypes.DRAFT,
    label: "Draft",
  },
  {
    value: StatusTypes.EDITED,
    label: "Edited",
  },
  {
    value: StatusTypes.IN_PROGRESS,
    label: "In Progress",
  },
  {
    value: StatusTypes.COMPLETED,
    label: "Completed",
  },
  {
    value: StatusTypes.CANCELED,
    label: "Canceled",
  },
];

export const JOBTYPE_MESSAGES = {
  ENTER_CUSTOMER: "Please select a customer",
  ENTER_PROJECT: "Please select a project",
  ENTER_START_TIME: "Please enter start time",
  ENTER_NOE: "Please enter NOE value",
  VALID_NOE: "Please enter a valid NOE value",
  ENTER_EMPLOYEES: "Please select an employees",
  ENTER_SUPERVISOR: "Please select a supervisor",

  JOB_ADDED_SUCCESS: "added successfully",
  JOB_MESSAGE_LIMIT: "Job description should be less than 200 characters",
};

export const FLEETS_MESSAGES = {
  CREATE_SUCCESS: "New Fleet created successfully",
  UPDATE_SUCCESS: "Fleet Information updated successfully",
  FLEET_OPTION_INPUT_VALIDATION_ERROR: "Name is required",

  FLEET_ADDED_SUCCESS: "Fleet added successfully",

  ENTER_CUSTOMER: "Please select a customer",
  ENTER_PROJECT: "Please select a project",
  ENTER_TIME: "Please select a time",
  ENTER_JOB_DESCRIPTION: "Please enter job description",
};

export const ROSTER_MESSAGES = {
  MOVE_EMPLOYEE_SUCCESS: "Employee moved successfully",
  JOB_Added_SUCCESS: "Job Added Successfully !! JK feature in progress",
  EMPLOYEE_START_TIME_UPDATED_SUCCESS:
    "Employee start time updated successfully",
  NO_CHANGES: "No changes detected",
  DELETED_SUCCESS: "Deleted successfully",
};
